/*
 * Copyright (c) 2017-2019. Code réalisé par IpsoSenso
 */

import { combineReducers } from 'redux'
import * as actions from 'isotope-client/modules/langue/services/langueActions'
import { GlOBAL_LANGUAGE_ID } from '../../../utils/constants'

// Surcharge du reducer langue par défaut pour gérer la langue default du multivalué
const byId = (state = {}, action) => {
	switch (action.type) {
		case actions.LOAD_LANGUES_SUCCESS:
			return action.payload.filter(lang => lang.id !== GlOBAL_LANGUAGE_ID).reduce((res, item) => ({
				...res,
				[item.id]: item
			}), {})
		case actions.LOAD_LANGUES_ERROR:
			return {}
		default:
			return state;
	}
}

export const langues = combineReducers({
	byId
})

export default langues

